import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Stack from '@mui/material/Stack'
import { FormProvider, useForm } from 'react-hook-form'
import { RegisteredTextField } from '../../../../components/fields/TextField'
import { SourceTypeSelect } from './AdminSourceTypeSelect'
import { intersection, isExternalLink } from './utils'
import { RegisteredDateTimePicker } from '../../../../components/fields/DateTimePicker'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import {
    singularIssueSourceTypes,
    singularWarrantSourceTypes,
    singularConvertibleSourceTypes,
} from '../../../../utils/issues/sourceTypes'
import { SourceUrl } from './AdminSourceUrl'
import { SourceType } from 'types/SourceType'
import { SourceForm } from '../../types/SourceForm'
import { TransactionType } from 'types/TransactionType'

export function EditSourceDialog({
    open,
    onUpdate,
    setOpen,
    source,
    sources,
    transactionType,
}: {
    onUpdate: (s: SourceForm) => boolean
    open: boolean
    setOpen: (val: boolean) => void
    source: SourceForm
    sources: SourceForm[]
    transactionType: TransactionType
}) {
    const formMethods = useForm<SourceForm>({ defaultValues: source })
    const handleUpdateSource = () => {
        const values = formMethods.getValues()
        if (onUpdate(values)) {
            setOpen(false)
        }
    }
    const registeredSourceTypes = sources
        ?.map((source) => source.sourceType)
        .filter((sourceType) => sourceType !== source.sourceType) as SourceType[]

    const singularSourceTypes =
        transactionType === 'Warrant'
            ? singularWarrantSourceTypes
            : transactionType === 'Convertible'
              ? singularConvertibleSourceTypes
              : singularIssueSourceTypes

    const publicationSource = sources?.find((s) => s.sourceType === 'Publication')

    const publicationDate = publicationSource?.publishedDate ? new Date(publicationSource?.publishedDate) : undefined

    return (
        <FormProvider {...formMethods}>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Redigera källa</DialogTitle>
                <DialogContent>
                    <Stack spacing={2}>
                        <SourceUrl source={source} />
                        <RegisteredTextField label='Intern kommentar' name='internalComment' />
                        <SourceTypeSelect
                            label='Typ'
                            formMethods={formMethods}
                            transactionType={transactionType}
                            setOfTypes={
                                source.sourceUrl && isExternalLink(source.sourceUrl)
                                    ? 'linkedSource'
                                    : source.sourceUrl
                                      ? 'uploadedSource'
                                      : 'internalSource'
                            }
                            props={{ fullWidth: true }}
                            excludeSourceTypes={intersection(singularSourceTypes, registeredSourceTypes)}
                        />
                        {source.sourceUrl && <RegisteredTextField label='Titel' name='title' />}
                        {source.sourceUrl && (
                            <RegisteredDateTimePicker
                                label='Publicerad'
                                name='publishedDate'
                                minDate={publicationDate}
                            />
                        )}
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Avbryt</Button>
                    <Button onClick={handleUpdateSource}>OK</Button>
                </DialogActions>
            </Dialog>
        </FormProvider>
    )
}
